/* global $ */

import debounce from 'lodash/debounce';

const SEARCH_CLASS = '.js-media-search';

const Search = {
  create(node) {
    const debouncedSearch = debounce(this.onSearch.bind(this), 200);
    $(node).on('keyup', SEARCH_CLASS, debouncedSearch);
  },

  onSearch() {
    window.pubsub.publish('media:filter');
  },
};

export default Search;
